import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getAbnormalList} from '../../../apis/abnormal/abnormal'

const useQueryAbnormalList = (current_page: number) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.other.getAbnormalList(current_page),
        queryFn: async () => {
            const {data, pageInfo} = await getAbnormalList(current_page)
            return {data, pageInfo}
        },
    })

    return {data, refetch}
}

export default useQueryAbnormalList
